"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _PortalSettingsKeys = _interopRequireDefault(require("settings-ui-sdk/constants/PortalSettingsKeys"));

var _epics = _interopRequireDefault(require("settings-ui-sdk/Ecommerce/epics"));

var _epics2 = _interopRequireDefault(require("settings-ui-sdk/EcommerceImport/epics"));

var _epics3 = _interopRequireDefault(require("settings-ui-sdk/EcommerceWorkflows/epics"));

var _epics4 = _interopRequireDefault(require("settings-ui-sdk/ShopifyConnection/epics"));

var _epics5 = _interopRequireDefault(require("settings-ui-sdk/Integrations/epics"));

var _actions = require("settings-ui-sdk/PortalSettings/actions");

var _epics6 = require("settings-ui-sdk/PortalSettings/epics");

var _scopedEpic = _interopRequireDefault(require("settings-ui-sdk/scopedEpic"));

var _GetStartedCardActions = require("../actions/GetStartedCardActions");

var _epics7 = _interopRequireDefault(require("settings-ui-sdk/EcommerceV2/epics"));

var _reloadStoreList = require("../multistore/epics/reloadStoreList");

var _epics8 = _interopRequireDefault(require("settings-ui-sdk/EcommerceV2/Shopify/epics"));

var dismissCardEpic = (0, _scopedEpic.default)({
  scopedEpics: [_epics6.savePortalSetting],
  metaInitiatingActionType: _GetStartedCardActions.GetStartedCardActions.DISMISS_CARD,
  mapStateAndMetaActionToInitiatingActions: function mapStateAndMetaActionToInitiatingActions() {
    return [(0, _actions.savePortalSetting)(_PortalSettingsKeys.default.ECOMMERCE_GET_STARTED_DISMISSED, 'true')];
  }
});

var _default = (0, _reduxObservable.combineEpics)(_epics8.default, _epics.default, _epics2.default, _epics3.default, dismissCardEpic, _epics4.default, _epics5.default, _epics7.default, _reloadStoreList.reloadStoreListOnDisconnect);

exports.default = _default;
module.exports = exports.default;